// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/common/types/v1/sample_type.proto (package quanterix.common.types.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file quanterix/common/types/v1/sample_type.proto.
 */
export const file_quanterix_common_types_v1_sample_type: GenFile = /*@__PURE__*/
  fileDesc("CitxdWFudGVyaXgvY29tbW9uL3R5cGVzL3YxL3NhbXBsZV90eXBlLnByb3RvEhlxdWFudGVyaXguY29tbW9uLnR5cGVzLnYxKo0BCgpTYW1wbGVUeXBlEhsKF1NBTVBMRV9UWVBFX1VOU1BFQ0lGSUVEEAASFAoQU0FNUExFX1RZUEVfTk9ORRABEhoKFlNBTVBMRV9UWVBFX0NBTElCUkFUT1IQAhIXChNTQU1QTEVfVFlQRV9VTktOT1dOEAMSFwoTU0FNUExFX1RZUEVfQ09OVFJPTBAEYgZwcm90bzM");

/**
 * Represents a sample's type to determine how it
 *
 * This type is analogous to the legacy quanterix.protos.type.PlateWellType
 *
 * @generated from enum quanterix.common.types.v1.SampleType
 */
export enum SampleType {
  /**
   * Unspecified type, indicates sample type has not been set
   *
   * @generated from enum value: SAMPLE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Explicitly represents the absence of a sample, e.g. and empty plate well
   * that should be ignored for the purposes of processing and / or analysis.
   *
   * @remarks
   * This type is equivalent to quanterix.protos.type.PLATE_WELL_TYPE_EMPTY
   *
   * @generated from enum value: SAMPLE_TYPE_NONE = 1;
   */
  NONE = 1,

  /**
   * Represents a sample of known concentration, used to derive the
   * concentrations of other samples
   *
   * @generated from enum value: SAMPLE_TYPE_CALIBRATOR = 2;
   */
  CALIBRATOR = 2,

  /**
   * Represents a sample containing an unknown concentration of a target
   * analyte
   *
   * @remarks
   * This type is equivalent to quanterix.protos.type.PLATE_WELL_TYPE_SPECIMEN
   *
   * @generated from enum value: SAMPLE_TYPE_UNKNOWN = 3;
   */
  UNKNOWN = 3,

  /**
   * Represents a sample of a known expected concentration, used to evaluate
   * the quality of a dataset
   *
   * @generated from enum value: SAMPLE_TYPE_CONTROL = 4;
   */
  CONTROL = 4,
}

/**
 * Describes the enum quanterix.common.types.v1.SampleType.
 */
export const SampleTypeSchema: GenEnum<SampleType> = /*@__PURE__*/
  enumDesc(file_quanterix_common_types_v1_sample_type, 0);

